<h2 mat-dialog-title class="auditTrain-heading"><a style="color: gray; font-size: 22px;font-family: sans-serif;"><b>{{ShowLabelContent()}}</b></a>
</h2>
<div class="row">
    <div class="form-horizontal" style="padding: 15px;padding-left: 30px;">
        <div class="row" style="padding-top:7px;">
            <div class="col-md-12">
                <div class="row form-group">
                    <span class="col-sm-4" *ngIf="_data.FTERecord.ActionType == 'Approve'" style="padding-top: 7px;">Business case<span style="color: red;">*:</span></span>
                    <span class="col-sm-4" *ngIf="_data.FTERecord.ActionType == 'Return'" style="padding-top: 7px;">Return Comments<span style="color: red;">*:</span></span>
                    <div class="col-md-8 col-sm-8">
                    <div style="padding-right: 10px;" *ngIf="(_data.IsAdmin == true || _data.IsPartner == true) && _data.FTERecord.RequestStatusID == 4">
                        <input type="text" id="txtPartnerComments" maxlength="500" name="txtPartnerComments" class="form-control"
                        [(ngModel)]="_data.FTERecord.PartnerComments" autocomplete="off">
                    </div>
                    <div style="padding-right: 10px;" *ngIf="(_data.IsAdmin == true || _data.IsSLHR == true) && _data.FTERecord.RequestStatusID == 5">
                        <input type="text" id="txtSLHRComments" maxlength="500" name="txtSLHRComments" class="form-control"
                        [(ngModel)]="_data.FTERecord.SLHRReturnComments" autocomplete="off">
                    </div>
                  </div>
                </div>
            </div>
        </div>
    </div>
</div>
<div class="modal-footer">
        <button type="button" class="btn btn-primary auditTrain-btn"
        (click)="UpdatePartnerAction()">OK</button>
        <!--  -->
    <button type="button" class="btn btn-primary auditTrain-btn"
        (click)="closeDialog()">Close</button>
</div>
<br>
